import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { getLinkClasses } from './LinkClasses';
export const Link = t0 => {
  const $ = _c(23);
  let LeadingIcon;
  let TrailingIcon;
  let as;
  let color;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as,
      disabled: t1,
      color,
      underline: t2,
      leadingIcon: LeadingIcon,
      trailingIcon: TrailingIcon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = LeadingIcon;
    $[2] = TrailingIcon;
    $[3] = as;
    $[4] = color;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    LeadingIcon = $[1];
    TrailingIcon = $[2];
    as = $[3];
    color = $[4];
    props = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  const disabled = t1 === undefined ? false : t1;
  const underline = t2 === undefined ? "solid" : t2;
  let t3;
  if ($[8] !== color || $[9] !== disabled || $[10] !== underline) {
    t3 = getLinkClasses({
      disabled,
      color,
      underline
    });
    $[8] = color;
    $[9] = disabled;
    $[10] = underline;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const {
    linkClasses
  } = t3;
  const Component = as || "a";
  let t4;
  if ($[12] !== LeadingIcon) {
    t4 = !!LeadingIcon && <LeadingIcon data-testid="leading-icon" className="h-4" />;
    $[12] = LeadingIcon;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== TrailingIcon) {
    t5 = !!TrailingIcon && <TrailingIcon data-testid="trailing-icon" className="h-4" />;
    $[14] = TrailingIcon;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== Component || $[17] !== disabled || $[18] !== linkClasses || $[19] !== props || $[20] !== t4 || $[21] !== t5) {
    t6 = <Component {...props} className={linkClasses} disabled={disabled}>{t4}{props.children}{t5}</Component>;
    $[16] = Component;
    $[17] = disabled;
    $[18] = linkClasses;
    $[19] = props;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};